import { DataVersion, LocationIncidentsDTO } from '@hakimo-ui/hakimo/types';
import { withDataVersion } from '@hakimo-ui/hakimo/util';
import useAuthenticatedRequest from '../shared/useAuthenticatedRequest';

export function useLocationIncidents(
  searchParams: string,
  refetchInterval: number,
  onSuccess?: (data: LocationIncidentsDTO) => void,
  disabled = false,
  keepPreviousData = false,
  dataVersion?: DataVersion
) {
  const url = `/v2/orm/location_incidents/?${searchParams}`;
  const request = new Request(url);
  withDataVersion(request, dataVersion);

  return useAuthenticatedRequest<LocationIncidentsDTO>(request, {
    queryKey: ['locationIncidents', { searchParams, dataVersion }],
    responseModifier: async (response) => {
      const respJson = await response.json();
      const payload = respJson.payload;

      // Initializing reported_cameras as cameras
      if (payload && payload.items) {
        payload.items = payload.items.map((incident: any) => ({
          ...incident,
          reported_cameras: incident.reported_cameras || incident.cameras || [],
        }));
      }

      return payload;
    },
    refetchInterval,
    refetchIntervalInBackground: true,
    onSuccess,
    enabled: !disabled,
    keepPreviousData,
  });
}

export default useLocationIncidents;
